import React from 'react';
import './loadingPage.scss';

export default props => (
  <div className="box-loading">
    <i className="fa fa-refresh fa-spin fa-3x fa-fw" aria-hidden="true"></i>
  </div>
);
